import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { GlobalsStore } from '../../../stores/globals.state';
import { ButtonModule } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { Bookmark } from '../../../models/bookmark';
import { TableRowAction } from '../table-row-indicator/table-row-indicator.component';
import { NgIf } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { RoutingService } from '../../../services/routing.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-table-row-bookmark]',
  standalone: true,
  imports: [ButtonModule, RouterLink, NgIf, TooltipModule],
  templateUrl: './table-row-bookmark.component.html',
  styleUrl: './table-row-bookmark.component.scss',
})
export class TableRowBookmarkComponent {
  readonly globalStore = inject(GlobalsStore);
  @Input() item!: Bookmark;
  @Input() actions: TableRowAction[] = [];
  @Input() external = false;
  @Output() closeEvent = new EventEmitter<void>();

  constructor(private routingService: RoutingService) {}

  /**
   * Closes the parent component or container by emitting the close event.
   *
   * @return {void} Does not return a value.
   */
  closeParent(): void {
    this.closeEvent.emit();
  }

  /**
   * Navigates to a specific bookmark within the Atlas application by its unique identifier.
   *
   * @param {string} bookmarkId - The unique identifier for the bookmark to open in Atlas.
   * @return {Promise<void>} A promise that resolves when the navigation is successfully completed.
   */
  openInAtlas(bookmarkId: string): void {
    this.routingService.openBookmarkRoute(bookmarkId).then(() => {
      this.closeParent();
    });
  }
}
